import { createSlice } from "@reduxjs/toolkit";
import { fetchProviderDetails } from "../../Thunk/getProfileData/getProviderDetailsThunk";
export interface AppState {
  ProviderDetails: any;
  isLoading: boolean;
  error: string | null | undefined;
}

const initialState: AppState = {
  ProviderDetails: null,
  isLoading: false,
  error: null,
};

const ProviderDetailSlice = createSlice({
  name: "providerDetails",
  initialState,
  reducers: {
    // Your other reducers go here
    resetState: () => initialState, 
  },
  extraReducers: (builder) => {

    builder
      .addCase(fetchProviderDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProviderDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ProviderDetails = action.payload;
      })
      .addCase(fetchProviderDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default ProviderDetailSlice;
